
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/text-messages",
      function () {
        return require("private-next-pages/text-messages/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/text-messages"])
      });
    }
  